interface IShouldClearShareQueryOnToggleProps {
  selectedUuids: string[];
  toggledUuid: string;
  // NOTE: Omitted by pickers whose endpoint takes an unbounded selection.
  maxSelected?: number;
}

// NOTE: NSAI-7350 — a pick consumes the query in every share picker (web and
// mobile): the new chip stands for the member that was typed, so text left
// beside it reads as a second, unfinished entry. Only a pick that actually
// grows the selection clears it — unticking keeps the user in the filtered
// list they are working through, and a pick refused at the cap changes nothing.
export const shouldClearShareQueryOnToggle = ({
  selectedUuids,
  toggledUuid,
  maxSelected,
}: IShouldClearShareQueryOnToggleProps): boolean => {
  if (selectedUuids.includes(toggledUuid)) return false;
  if (maxSelected !== undefined && selectedUuids.length >= maxSelected) {
    return false;
  }
  return true;
};
